import { render } from "./CollectionsContainer.vue?vue&type=template&id=43ef824d&scoped=true"
import script from "./CollectionsContainer.vue?vue&type=script&lang=js"
export * from "./CollectionsContainer.vue?vue&type=script&lang=js"

import "./CollectionsContainer.vue?vue&type=style&index=0&id=43ef824d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43ef824d"]])

export default __exports__